import React from "react"

import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { useMetaImageQuery } from "../../queries/useMetaImageQuery"
export default ({ image, alt, className, height = "inherit" }) => {
  const data = useMetaImageQuery(image)

  var dataToShow = data.allFile.edges.filter(file => file.node.base === image)

  if (dataToShow.length > 0) {
    return (
      <GatsbyImage
        alt={alt}
        className={className}
        style={{ width: "100%", height }}
        image={getImage(dataToShow[0].node)}
      />
    )
  } else {
    return <></>
  }
}
